// extracted by mini-css-extract-plugin
export default {"imageContainer":"i2-z","summaryPar":"j2-z","ratingCategories":"k2-z","reviewerInfo":"l2-z","reviewTypes":"m2-z","expanded":"n2-z"};